export interface VoiceDisplayPreferences {
  waitForAudio: boolean;
  voiceBubble: boolean;
}
const prefix = 'zhixin.voiceDisplay.';
export function loadVoiceDisplayPreferences(userId?: string): VoiceDisplayPreferences {
  if (!userId) return { waitForAudio: false, voiceBubble: false };
  try {
    const raw = JSON.parse(localStorage.getItem(prefix + userId) ?? '{}') as Partial<VoiceDisplayPreferences>;
    return { waitForAudio: raw.waitForAudio === true, voiceBubble: raw.voiceBubble === true };
  } catch { return { waitForAudio: false, voiceBubble: false }; }
}
export function saveVoiceDisplayPreferences(userId: string, value: VoiceDisplayPreferences): void {
  localStorage.setItem(prefix + userId, JSON.stringify(value));
}
export function rememberVoiceReply(userId: string, messageId: string, duration: number | null, selection?: string): void {
  try { localStorage.setItem(`${prefix}${userId}.reply.${messageId}`, JSON.stringify({ duration, selection })); }
  catch { /* Audio remains in the durable device store if presentation storage is full. */ }
}
export function readVoiceReply(userId: string, messageId: string, selection?: string): { duration: number | null } | undefined {
  try {
    const raw: unknown = JSON.parse(localStorage.getItem(`${prefix}${userId}.reply.${messageId}`) ?? 'null');
    if (raw && typeof raw === 'object' && 'duration' in raw) {
      if (selection !== undefined && (!('selection' in raw) || raw.selection !== selection)) return undefined;
      const duration = raw.duration;
      return { duration: typeof duration === 'number' && Number.isFinite(duration) && duration > 0 ? duration : null };
    }
  } catch { /* Missing or invalid presentation data falls back to text. */ }
  return undefined;
}
